export default function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/@babel/runtime/helpers/esm/extends.js
// module id = ../../node_modules/@babel/runtime/helpers/esm/extends.js
// module chunks = 18